import React from 'react';
import { Toaster } from 'react-hot-toast';

// Re-export toastService for convenience
export { toastService } from 'App/services/toastService';

const NotificationContainer: React.FC = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 5000,
        style: {
          margin: '10px 5px 2px 1px',
          borderRadius: '10px',
        },
        success: {
          style: {
            color: 'green',
          },
        },
        error: {
          style: {
            color: 'red',
          },
        },
      }}
    />
  );
};

export default NotificationContainer;
